import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import ContactFormCmp from "../../components/ContactFormCmp";

const GovernmentSchemes = () => {
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        phone: "",
        location: "",
        budget: "",
        message: "",
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const submitMessage = (e) => {
        e.preventDefault();
        // console.log(formData);
        // API call or validation logic here
        alert(
            'Due to some technical issues, we could not process your Form Submission.'
        );

        setFormData({
            fullName: "",
            email: "",
            phone: "",
            location: "",
            budget: "",
            message: "",
        });
    };

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    return (
        <>
            {/*Start breadcrumb area paroller*/}
            <section className="breadcrumb-area">
                <div className="breadcrumb-area-bg" style={{ backgroundImage: 'url(/assets/images/services/banners/GovernmentSchemes.jpg)' }}>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="inner-content">
                                <div className="title">
                                    <h2>Building Penalisation Scheme</h2>
                                </div>
                                <div className="breadcrumb-menu">
                                    <ul>
                                        <li><Link to="/">Home</Link></li>
                                        <li><i className="fa fa-angle-right" aria-hidden="true" /></li>
                                        <li className="active">Building Penalisation Scheme</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/*End breadcrumb area*/}

            <div className="service-details-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="service-details-sec1">
                                <div className="d-flex">
                                    <div className="flex-shrink-0">
                                        <img className="serv-im" src="/assets/images/Group2.png" alt="Architecture Design" />
                                    </div>
                                    <div className="flex-grow-1 ms-3">
                                        <h3 className="serv-head">Building Penalisation Scheme (BPS)</h3>
                                        <p className="serv-txt">The Building Penalization Scheme (BPS) allows property owners to legalize buildings constructed without
                                            approval or with plan deviations. Our team assists with documentation, drawings, and submission for legal
                                            approval.</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="serv-sec2">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="serv-sec2-leftsec">
                                    <h3 className="serv-sec2-leftsec-head">What We Offer</h3>
                                    <p className="serv-sec2-leftsec-txt">The Building Penalisation Scheme (BPS) allows property owners to legalize buildings constructed without approval or with deviations from approved plans. Our team assists with documentation, drawings, and submission to obtain legal status.</p>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">BPS Application Filing</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Building Plan Verification</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Technical Drawings Preparation</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Documentation & Compliance Support</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Online Portal Submission</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Penalty Fee Calculation</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Authority Coordination & Follow-ups</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="points-sect">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0">
                                                <img className="icon-im" src="/assets/images/qwe.png" alt="Point" />
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <p className="icons-txt">Complete BPS Regularisation Support</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="serv-sec-3box">
                                        <h3 className="serv-sec-3box-head">Key Benefits</h3>
                                        <ul className="serv-sec-3box-ul">
                                            <li>• ⁠Legal recognition for unauthorized buildings</li>
                                            <li>• Eligibility for property tax registration and utilities</li>
                                            <li>• ⁠Increased property value and resale potential</li>
                                            <li>• ⁠Avoidance of legal issues and penalties</li>
                                            <li>• Compliance with Andhra Pradesh municipal regulations</li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className='contactus-section2Right'>
                                    <h3 className='contactus-section2RightHead'>Contact for Service</h3>
                                    <p className='contactus-section2Righttxt'>Fill in your details and we'll get back to you within 24 hours.</p>
                                    <ContactFormCmp serviceName="BPS" />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default GovernmentSchemes;